import styled from 'styled-components';
import { COLORS } from 'modules/core/theme/colors';
import Image from 'react-bootstrap/Image';

export const CardContainer = styled.div`
  width: 100%;
  border: 1px solid ${COLORS.GREY_9};
  border-radius: 5px;
  padding: 10px 20px;
  margin-bottom: 20px;
`;

export const Title = styled.p`
  color: ${COLORS.GREY_3};
  font-size: 14px;
  font-style: italic;
`;

export const Price = styled.p`
  color: ${COLORS.BLUE_7};
  font-size: 24px;
  font-weight: 800;
  margin-bottom: 0;
`;

export const PriceDescription = styled.p`
  color: ${COLORS.BLUE_7};
  font-size: 19px;
  margin-bottom: 0;
`;

export const PriceContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
`;

export const Img = styled(Image)`
  width: 70%;
`;

export const ImgContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
